module.exports = __webpack_public_path__ + "fonts/SpoqaHanSansNeo-Light.f0124504.woff";